import qs from 'qs';
import { SearchForRetail } from '@/client/api';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
export const transformSeoDashboardError = (response) => ({
    status: response.status,
    message: 'Error occurred while fetching the SEO Analytics',
    data: response.data,
});
/**
 * RTK Query endpoint for SEO Dashboard analytics data.
 *
 * The response is the raw `SeoAnalyticsDto` — the domain transformation
 * (`parseSeoAnalytics`) is applied downstream in the platform-services
 * hook so that the Redux cache stays JSON-serializable.
 *
 * @see src/platform-services/seo-dashboard/useGetSeoDashboardAnalytics.ts
 */
export const seoDashboardApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getSeoDashboardAnalytics: builder.query({
            query: ({ collection, siteFilterId, filters }) => {
                const queryString = qs.stringify(Object.assign({ siteFilterId, collection }, filters), { arrayFormat: 'comma' });
                return {
                    url: `/${SearchForRetail.ANALYTICS_PATH}/seoAnalytics?${queryString}`,
                    method: 'GET',
                };
            },
            transformErrorResponse: transformSeoDashboardError,
            providesTags: [CC_API_TAGS.SeoDashboardAnalytics],
        }),
    }),
});
export const { useGetSeoDashboardAnalyticsQuery } = seoDashboardApi;
